var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.998,
    height: 47,
    viewBox: "0 0 46.998 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-7925.501 -2610.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M8052.156,2622.591v33.323a1.722,1.722,0,0,1-1.8,1c-6.43-.022-12.861-.012-19.289-.012h-.558a6.691,6.691,0,0,0,.926-3.693q-.023-11.312-.01-22.625a5.818,5.818,0,0,0-5.964-6.018q-3.818,0-7.635,0h-.514v-.577c0-3.756.017-7.511-.013-11.267a1.725,1.725,0,0,1,1-1.808h22.246q0,5.042,0,10.085a1.39,1.39,0,0,0,1.582,1.591Zm-10.882,6.782c0-.323.006-.606,0-.889a1.341,1.341,0,0,0-1.32-1.4,1.365,1.365,0,0,0-1.356,1.377,5.675,5.675,0,0,0,0,.718c.021.269-.07.384-.342.462a4.739,4.739,0,0,0-3.037,2.587,4.6,4.6,0,0,0,1.73,6.2c.426.241.852.491,1.295.7a.538.538,0,0,1,.357.578c-.013,2.005-.008,4.01-.008,6.015,0,.131-.015.262-.024.426a2,2,0,0,1-.466-.08c-.623-.275-1.247-.545-1.851-.86a1.374,1.374,0,0,0-1.849.422,1.341,1.341,0,0,0,.415,1.852,7.684,7.684,0,0,0,2.706,1.226c.344.072.7.117,1.073.18,0,.381-.015.739,0,1.1a1.359,1.359,0,0,0,1.377,1.356,1.335,1.335,0,0,0,1.295-1.381c.01-.4,0-.8,0-1.205a6.1,6.1,0,0,0,2.976-1.717,5.731,5.731,0,0,0,.512-7.43,5.912,5.912,0,0,0-3-1.919.594.594,0,0,1-.5-.688c.032-1.391.013-2.783.013-4.174v-.608l.128-.1c.357.239.731.458,1.073.72a1.371,1.371,0,0,0,1.622.109,1.277,1.277,0,0,0,.535-1.488,2.086,2.086,0,0,0-.546-.794A5.342,5.342,0,0,0,8041.274,2629.374Zm-11.9-14.417c-1.738,0-3.478-.012-5.218.01a1.914,1.914,0,0,0-.882.238,1.265,1.265,0,0,0-.548,1.441,1.332,1.332,0,0,0,1.363,1q5.223.007,10.439,0a1.372,1.372,0,0,0,1.547-1.358c-.008-.814-.619-1.335-1.57-1.335Zm0,5.389c-1.738,0-3.478-.011-5.218.01a1.892,1.892,0,0,0-.88.241,1.262,1.262,0,0,0-.544,1.442,1.334,1.334,0,0,0,1.365,1q5.22.005,10.439,0a1.359,1.359,0,1,0,.014-2.694Z",
    transform: "translate(-80.157)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M7926.083,2822.154h22.842v.487q0,8.539,0,17.077a3.206,3.206,0,0,1-3.42,3.431q-8.013,0-16.025,0a3.2,3.2,0,0,1-3.395-3.368q0-8.584,0-17.168Zm5.941,6.6a1.362,1.362,0,1,0-1.373-1.359A1.371,1.371,0,0,0,7932.024,2828.751Zm5.471,0a1.362,1.362,0,1,0-1.361-1.371A1.369,1.369,0,0,0,7937.5,2828.751Zm6.859-1.357a1.369,1.369,0,1,0-1.375,1.357A1.37,1.37,0,0,0,7944.354,2827.394Zm-10.963,5.456a1.369,1.369,0,1,0-1.35,1.383A1.37,1.37,0,0,0,7933.392,2832.85Zm5.48.041a1.369,1.369,0,1,0-1.389,1.343A1.368,1.368,0,0,0,7938.872,2832.891Zm5.482-.016a1.369,1.369,0,1,0-1.371,1.359A1.371,1.371,0,0,0,7944.354,2832.875Zm-10.963,5.009a1.37,1.37,0,1,0-1.357,1.375A1.372,1.372,0,0,0,7933.392,2837.883Zm4.09,1.375a1.362,1.362,0,1,0-1.348-1.385A1.371,1.371,0,0,0,7937.481,2839.258Zm5.52-2.724a1.362,1.362,0,1,0,1.354,1.377A1.37,1.37,0,0,0,7943,2836.534Z",
    transform: "translate(-0.073 -186.246)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M7926.019,2753.5c0-1.175-.055-2.318.014-3.454a3.154,3.154,0,0,1,3.23-2.91q6.413-.01,12.83,0c1.154,0,2.313-.005,3.469,0a3.19,3.19,0,0,1,3.287,3.286c.008,1.017,0,2.034,0,3.08Z",
    transform: "translate(0.001 -119.916)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M8242.837,2627.34h-8.105v-8.105Z",
    transform: "translate(-271.84 -7.304)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M8218.414,2856.7a2.579,2.579,0,0,1,1.955,2.538,3.234,3.234,0,0,1-1.955,2.982Z",
    transform: "translate(-257.353 -216.36)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M8186.646,2790.461v3.827a1.749,1.749,0,0,1-1.227-1.643A2.35,2.35,0,0,1,8186.646,2790.461Z",
    transform: "translate(-228.305 -158.034)",
    fill: "#bc5e0a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExp3);
export default __webpack_public_path__ + "static/media/exp-3.ce80dd00eb7047d0c8dcfdcf6cf16ce2.svg";
export { ForwardRef as ReactComponent };